if (process.env.NODE_ENV === "production") {
	globalThis.window?.addEventListener("error", (event) => {
		try {
			// Try to avoid error-logging-loop
			const data = {
				error: event.error?.message ?? event.message ?? null,
				file: event.filename,
				line: event.lineno ?? 0,
				column: event.colno ?? 0,
				stack: event.error?.stack ?? null,
			};

			fetch("/data/Logger/LogError", {
				body: JSON.stringify(data),
				headers: {
					Accept: "application/json",
					"Content-Type": "application/json; charset=utf-8",
					"X-Requested-With": "XMLHttpRequest",
				},
				method: "POST",
			});
		} catch (ex) {
			// ignore
		}
	});
}
